import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Typography,
    Paper,
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import { api, Balance } from "../api";
import { useCustomer } from "../../../context/CustomerContext";
import { usePresetDialogs } from "../../dialog";
import { useFetch } from "./useFetch";

interface UnsubscribeFormProps {
    onClose: () => void;
}

const UnsubscribeForm: React.FC<UnsubscribeFormProps> = ({ onClose }) => {
    const { t } = useTranslation();
    const { customerData, isLoading } = useCustomer();
    const { showConfirm, showInfo, DialogComponent } = usePresetDialogs();
    const { data: isSubscribed, loading: isSubscriptionLoading } = useFetch<boolean>(api.getSubscription, false, customerData?.customer);
    const { data: balance, } = useFetch<Balance | null>(api.getBalance, null);
    
    const handleCancelClick = async () => {

        if (!customerData?.customer) {
            alert('no customer');
            return;
        }

        if (!isSubscribed) {
            await showInfo(t('UnsubscribeForm.Subscription_Not_Found'), t('UnsubscribeForm.Warning'));
            return;
        }

        const result = await showConfirm(
            t('UnsubscribeForm.Your_banking_subscription_will_be_terminated'),
            t('UnsubscribeForm.Confirm_Action'),
        );

        if (result) {
            if (await api.suspendService(customerData?.customer)) {
                await showInfo(t('UnsubscribeForm.Subscription_is_stopped'), t('UnsubscribeForm.Warning'));
            } else {
                await showInfo(t('UnsubscribeForm.UnknownError'), t('UnsubscribeForm.Warning'));
            }
            onClose();
        }
    };

    const handleClose = () => {
        onClose();
    };

    if (isLoading || isSubscriptionLoading) {
        return (
        <Paper elevation={3} sx={{ maxWidth: 420, mx: "auto", p: 3, mt: 4 }}>
            <Typography variant="h5" gutterBottom>
                {/* {t('UnsubscribeForm.Loading')} */}
                Loading...
            </Typography>
        </Paper>
        );
    }

    if (!isSubscribed) {
        return (
        <Paper elevation={3} sx={{ maxWidth: 420, mx: "auto", p: 3, mt: 4 }}>
            <Typography variant="h5" gutterBottom>
                Підписка не знайдена
            </Typography>
            <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
                <Button variant="outlined" onClick={onClose}>
                    Закрити
                </Button>
            </Box>
        </Paper>
        );
    }
    return (
        <Paper elevation={3} sx={{ maxWidth: 420, mx: "auto", p: 3, mt: 4 }}>
            
            {DialogComponent}
            
            <Typography variant="h5" gutterBottom>
                Відміна підписки
            </Typography>

            <Box sx={{ mt: 2 }}>
                <Button variant="contained" onClick={handleCancelClick} disabled={!(balance?.endDate && balance.endDate > new Date())} fullWidth>
                    {t('UnsubscribeForm.Stop_subscription_')}
                </Button>
            </Box>
        </Paper>
    );
}

export default UnsubscribeForm;
